<template>
  <v-card outlined class="order-search-card">
    <v-card-text class="pa-4">
      <div class="order-entry-grid">
        <div class="entry-field product-entry">
          <div class="field-label">Product Search</div>
          <AutoComplete
            :PriceTierId="priceTierId"
            @submit="productSubmitted"
            ref="selectedProductChild"
            @emptyEntryBar="emptyEntryBar"
          />
        </div>

        <div class="entry-field item-name-entry">
          <div class="field-label">Item Name</div>
          <v-text-field
            @focus="$event.target.select()"
            label="Item Name"
            :disabled="lockProductName"
            @keyup.enter="$refs.qty.focus"
            v-model="name"
            outlined
            dense
            hide-details
            ref="itemName"
          />
        </div>

        <div class="entry-field qty-entry">
          <div class="field-label">Qty</div>
          <v-text-field
            class="centered-input"
            @focus="$event.target.select()"
            ref="qty"
            outlined
            dense
            hide-details
            label="Qty"
            type="number"
            @keyup.enter="$refs.price.focus"
            v-model="qty"
          />
        </div>

        <div class="entry-field price-entry">
          <div class="field-label">Price</div>
          <v-text-field
            class="right-input"
            ref="price"
            @focus="$event.target.select()"
            label="Price"
            v-model="price"
            outlined
            dense
            hide-details
            type="number"
            @keyup.enter="submit"
          />
        </div>

        <div class="entry-field total-entry">
          <div class="field-label">Ext Amount</div>
          <v-text-field
            disabled
            class="right-input"
            ref="extAmount"
            outlined
            dense
            hide-details
            v-model="total"
            label="Ext Amount"
          />
        </div>

        <div class="entry-button">
          <v-btn
            color="primary"
            rounded
            ref="addbutton"
            :block="$vuetify.breakpoint.smAndDown"
            :large="$vuetify.breakpoint.mdAndUp"
            :disabled="!selectedProduct"
            @click="submit"
          >
            <v-icon :left="!$vuetify.breakpoint.smAndDown" small>
              mdi-cart-plus
            </v-icon>
            <span v-if="!$vuetify.breakpoint.smAndDown">Add</span>
          </v-btn>
        </div>
      </div>

      <div
        v-if="selectedProduct && selectedProduct.unitCountInBox > 0"
        class="box-info"
      >
        The box contains
        <span class="font-weight-bold">{{
          selectedProduct.unitCountInBox
        }}</span>
        units. Unit price:
        <span class="font-weight-bold">{{
          selectedProduct.price | currency
        }}</span>
        Box price:
        <span class="font-weight-bold">{{
          selectedProduct.boxPrice | currency
        }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import orderService from "@/modules/Order/components/OldPublicCatalog/service.js";
import priceTierService from "@/modules/Product/PriceTier/service.js";
import { mapGetters } from "vuex";
import GlobalFunction from "@/mixins/GlobalFunction";
import AutoComplete from "@/modules/Product/components/AutoComplete.vue";
import _ from "lodash";

export default {
  name: "in-house-order-product-search-bar",

  props: {
    selectedCustomer: {
      default: null,
    },
    priceTierId: {
      default: null,
    },
  },

  components: {
    AutoComplete,
  },

  mixins: [GlobalFunction],

  data() {
    return {
      loading: false,
      Products: [],
      phoneSearch: null,
      selectedProduct: null,
      name: null,
      qty: 1,
      boxQty: 1,
      price: 0,
      total: 0,
    };
  },

  computed: {
    ...mapGetters("global", ["currentBusiness"]),

    lockProductName() {
      if (
        !this.currentBusiness ||
        !this.currentBusiness.metadata ||
        !this.currentBusiness.metadata.hasOwnProperty("lockProductName")
      ) {
        return true;
      }

      return !!this.currentBusiness.metadata.lockProductName;
    },
  },

  watch: {
    phoneSearch: _.debounce(function (val) {
      if (val && val.length > 2) {
        this.getProduct();
      }
    }, 300),

    qty() {
      this.updateTotal();
    },

    price() {
      this.updateTotal();
    },

    async priceTierId(val) {
      if (!this.selectedProduct) return;

      const tier = await this.getTierById(val);
      this.price = this.calculateTierPrice(
        this.selectedProduct.price,
        tier,
        this.selectedProduct.id
      );

      this.updateTotal();
    },

    selectedProduct(val) {
      if (!val) return;

      if (val.dynamicPrice) {
        val.price = val.dynamicPrice;
      }

      this.setProduct(val);
    },
  },

  created() {
    this.emptyEntryBar();
  },

  methods: {
    productSubmitted(product) {
      this.selectedProduct = product;
    },

    setProduct(product) {
      this.name = product.name;
      this.price = Number(product.price || 0);
      this.qty = 1;
      this.boxQty = 1;
      this.updateTotal();

      this.$nextTick(() => {
        if (this.lockProductName && this.$refs.qty) {
          this.$refs.qty.focus();
          return;
        }

        if (this.$refs.itemName) {
          this.$refs.itemName.focus();
        }
      });
    },

    updateTotal() {
      const qty = Number(this.qty || 0);
      const price = Number(this.price || 0);
      this.total = Number((qty * price).toFixed(2));
    },

    emptyEntryBar() {
      this.name = null;
      this.qty = 1;
      this.boxQty = 1;
      this.price = 0;
      this.total = 0;
      this.selectedProduct = null;

      this.$nextTick(() => {
        if (
          this.$refs.selectedProductChild &&
          this.$refs.selectedProductChild.emptyAutoComplete
        ) {
          this.$refs.selectedProductChild.emptyAutoComplete();
        }

        if (
          this.$refs.selectedProductChild &&
          this.$refs.selectedProductChild.$refs &&
          this.$refs.selectedProductChild.$refs.productSearchInput
        ) {
          this.$refs.selectedProductChild.$refs.productSearchInput.focus();
        }
      });
    },

    submit() {
      if (!this.selectedProduct) return;

      this.selectedProduct.Bar = {
        name: this.name,
        qty: Number(this.qty || 1),
        price: Number(this.price || 0),
        boxQty: Number(this.boxQty || 1),
      };

      this.$emit("submit", this.selectedProduct);
      this.emptyEntryBar();
    },

    async getTierById(id) {
      try {
        if (!id) return null;
        const response = await priceTierService.getById(id);
        return response.data;
      } catch (error) {
        console.error("Error fetching tier by ID:", error);
        return null;
      }
    },

    calculateTierPrice(originalPrice, selectedTier, productId) {
      if (!selectedTier) {
        return Number(originalPrice || 0);
      }

      let newPrice = Number(originalPrice || 0);

      if (selectedTier.discountType === "percentage") {
        const rate = Number(selectedTier.rate || 0);
        newPrice = newPrice - newPrice * (rate / 100);
      }

      if (selectedTier.discountType === "fixed") {
        const productTier = Array.isArray(selectedTier.ProductPrices)
          ? selectedTier.ProductPrices.find(
              (p) => Number(p.ProductId) === Number(productId)
            )
          : null;

        if (productTier) {
          newPrice = Number(productTier.price || 0);
        }
      }

      return Number(newPrice.toFixed(2));
    },

    getProduct() {
      this.loading = true;

      return orderService
        .getProduct({
          search: this.phoneSearch,
          hideParent: true,
        })
        .then((result) => {
          this.Products = result.data || [];

          if (
            this.currentBusiness &&
            this.currentBusiness.metadata &&
            this.currentBusiness.metadata.dynamicPrice
          ) {
            this.Products.forEach((row) => {
              row.dynamicPrice = this.getDynamicPrice(
                row,
                this.currentBusiness.metadata.dynamicPriceList
              );
            });
          }

          return result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.order-search-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.order-entry-grid {
  display: grid;
  grid-template-columns: minmax(260px, 1.4fr) minmax(260px, 1.2fr) 90px 120px 130px auto;
  gap: 12px;
  align-items: end;
}

.field-label {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}

.entry-button {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.box-info {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #0f172a;
  text-align: center;
  font-size: 13px;
}

.centered-input input {
  text-align: center;
}

.right-input input {
  text-align: right;
}

@media (min-width: 961px) and (max-width: 1264px) {
  .order-entry-grid {
    grid-template-columns: minmax(230px, 1.3fr) minmax(230px, 1fr) 80px 110px 120px 54px;
  }

  .entry-button .v-btn {
    min-width: 48px !important;
    padding: 0 12px !important;
  }
}

@media (min-width: 600px) and (max-width: 960px) {
  .order-entry-grid {
    grid-template-columns: 1.2fr 1.2fr 80px 100px 110px 48px;
    gap: 10px;
  }

  .field-label {
    font-size: 11px;
  }

  .entry-button .v-btn {
    min-width: 44px !important;
    padding: 0 10px !important;
  }
}

@media (max-width: 760px) {
  .order-entry-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .product-entry,
  .item-name-entry {
    grid-column: span 3;
  }

  .qty-entry,
  .price-entry,
  .total-entry {
    grid-column: span 1;
  }

  .entry-button {
    grid-column: span 3;
  }
}

@media (max-width: 599px) {
  .order-search-card .v-card__text {
    padding: 12px !important;
  }

  .order-entry-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .product-entry,
  .item-name-entry,
  .qty-entry,
  .price-entry,
  .total-entry,
  .entry-button {
    grid-column: span 1;
  }

  .entry-button .v-btn {
    width: 100%;
  }
}
</style>